import React from 'react';
import { Helmet } from 'react-helmet';
import { t } from '@lingui/macro';

import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';
import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';

type Props = {
  serviceTypeSlug: string;
  getServiceTypeName: (arg0: string) => string;
};

const HtmlHeader = ({ serviceTypeSlug, getServiceTypeName }: Props): JSX.Element => {
  const serviceType = getServiceTypeName(serviceTypeSlug);
  const brandDisplayName = getBrandDisplayName();
  const title = t`Search For Pet Care In Your Neighborhood | ${brandDisplayName}`;
  const description = getBrandSpecificValue({
    rover: t`${serviceType} on Rover.com connects you to a nationwide network of dog lovers for hire. Because we believe everyone should experience the love of a dog.`,
    catInAFlat: t`${serviceType} on Catinaflat.com connects you to a nationwide network of cat lovers for hire. Because we believe everyone should experience the love of a cat.`,
  });

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />

      <meta name="twitter:card" content="summary" />
      <meta property="og:type" content="website" />

      <meta property="og:description" content={description} />
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default HtmlHeader;
